import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type AdminEventLogItem = {
  insertId: string
  timestamp: string
  eventType: string
  message: string
  userId?: number | null
  companyId?: number | null
  shiftId?: number | null
  subjectUserId?: number | null
}

export type ListEventLogsResponse = {
  items: AdminEventLogItem[]
  nextCursor?: string | null
}

export type ListEventLogsParams = {
  startsAt: string
  endsAt: string
  companyId?: number
  userId?: number
  subjectUserId?: number
  shiftId?: number
  eventType?: string[]
  messageContains?: string
  cursor?: string
  limit?: number
}

export async function listEventLogs(
  params: ListEventLogsParams
): Promise<ListEventLogsResponse> {
  const result = await api.get<ListEventLogsResponse>('/admin/event_logs', {
    params,
    paramsSerializer: queryParamSerializer,
  })
  return result.data
}
